<template>
  <div class="record">
    <div class="headLine">供水管网漏损分析系统首页</div>
    <div class="menuBox">
      <div v-if="hasPermission(1)" class="boxList box00" @click="dataGo(10)">
        <img src="./historyOrder.png" alt="最新调度页面数据">
        <p>最新调度页面数据</p>
      </div>
      <div v-if="hasPermission(2)" class="boxList box06" @click="dataGo(6)">
        <img src="./historyOrder.png" alt="查询爬取西江数据">
        <p>查询爬取西江数据</p>
      </div>
      <div v-if="hasPermission(3)" class="boxList box05" @click="dataGo(5)">
        <img src="./historyOrder.png" alt="查询线上爬取数据">
        <p>查询线上爬取数据</p>
      </div>
      <div v-if="hasPermission(4)" class="boxList box07" @click="dataGo(7)">
        <img src="./historyOrder.png" alt="查询爬取丹灶数据">
        <p>查询爬取丹灶数据</p>
      </div>
      <div v-if="hasPermission(5)" class="boxList box00" @click="dataGo(0)">
        <img src="./historyOrder.png" alt="查询三水调度数据">
        <p>查询三水调度数据</p>
      </div>
      <div v-if="hasPermission(6)" class="boxList box01" @click="dataGo(1)">
        <img src="./createOrder.png" alt="现场抄表">
        <p>现场抄表</p>
      </div>
      <div v-if="hasPermission(7)" class="boxList box04" @click="dataGo(4)">
        <img src="./historyOrder.png" alt="现场抄表记录">
        <p>现场抄表记录</p>
      </div>
      <div v-if="hasPermission(8)" class="boxList box02" @click="dataGo(2)">
        <img src="./warning.png" alt="警报查看">
        <p>警报查看</p>
      </div>
      <div v-if="hasPermission(9)" class="boxList box03" @click="dataGo(3)">
        <img src="./warningComfirm.png" alt="警报确认">
        <p>警报确认</p>
      </div>
      <div v-if="hasPermission(10)" class="boxList box08" @click="dataGo(8)">
        <img src="./warningComfirm.png" alt="警报调整">
        <p>警报调整</p>
      </div>
      <div v-if="hasPermission(11)" class="boxList box09" @click="dataGo(11)">
        <img src="./warningComfirm.png" alt="管网巡查情况">
        <p>管网巡查情况</p>
      </div>
<!--      <div class="boxList box10" @click="dataGo(12)">-->
<!--        <img src="./warningComfirm.png" alt="第二水源巡查">-->
<!--        <p>第二水源巡查</p>-->
<!--      </div>-->
<!--      <div class="boxList box07" @click="dataGo(7)">-->
<!--        <img src="./salesCheck.png" alt="查询产销差">-->
<!--        <p>查询产销差</p>-->
<!--      </div>-->
      <a href="https://beian.miit.gov.cn/" class="bottomBeian">粤ICP备17114956号-2</a>
    </div>
  </div>
</template>

<script>
import http from '@/utils/http'

export default {
  data () {
    return {
      loading: true,
      popstateLock: 0, //是否监听物理返回键
      menuList: [], // 权限菜单列表
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate();
      }else{
        this.removePopstate();
      }
    }
  },
  mounted () {
    this.addPopstate(); //在导航栏挂载的时候，对物理返回键进行监听
    this.getPermissions(); // 获取用户权限
    
    // 监听页面刷新事件
    this.beforeUnloadHandler = () => {
      sessionStorage.removeItem('menuList');
    };
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  },
  destroyed(){
    this.removePopstate();
    // 移除页面刷新事件监听
    if (this.beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    }
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      //在没有传id的情况下，就是在系统首页，这个时候调用微信WeixinJSBridgeReady自带的API对返回键进行监听实现在首页返回关闭页面
      document.addEventListener("WeixinJSBridgeReady", function() {
        window.WeixinJSBridge.call("closeWindow");
      }, false);
      window.WeixinJSBridge.call("closeWindow");
    },
    // 获取用户权限
    getPermissions() {
           
      // 没有缓存或解析失败，重新获取
      this.$http.httpGet('/app/appTbUserInfo/nav').then(res => {
        if (res.code === 0 && res.menuList) {
          this.menuList = res.menuList;
        }
      }).catch(err => {
        console.error('获取权限失败:', err);
      });
    },
    // 检查是否有权限
    hasPermission(menuId) {
      if (!this.menuList || this.menuList.length === 0) {
        return false;
      }
      return this.menuList.some(menu => menu.menuId === menuId);
    },
    // 跳转到各页面中去
    dataGo(val) {
      if (val === 0) {  // 查询三水调度数据
        this.$router.push({ name: 'xjCheck' });
      } else if (val === 1) {  // 数据录入
        this.$router.push({ name: 'dataInside' });
      } else if (val === 2) {  // 警报查看
        this.$router.push({ name: 'warningCheck' });
      } else if (val === 3) {  // 警报确认
        this.$router.push({ name: 'warningMakesure' });
      } else if (val === 4) {  // 查询历史手抄数据
        this.$router.push({ name: 'recordCheck' });
      } else if (val === 5) {  // 查询线上爬取数据
        this.$router.push({ name: 'pressCheck' });
      } else if (val === 6) {  // 查询爬取流量
        this.$router.push({ name: 'flowCheck' });
      } else if (val === 7) {  // 查询爬取丹灶数据
        this.$router.push({ name: 'electricityCheck' });
      } else if (val === 8) {  // 警报调整
        this.$router.push({ name: 'monitorvalue' });
      } else if (val === 9) {  // 查询产销差
        this.$router.push({ name: 'salesCheck' });
      } else if (val === 10) {  // 最新调度数据
        this.$router.push({ name: 'latestData' });
      } else if (val === 11) {  // 管网巡查情况
        this.$router.push({ name: 'inspectionList' });
      } else if (val === 12) {  // 第二水源巡查
        this.$router.push({ name: 'latestData' });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.record ::v-deep {
  position: relative;
  .headLine {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 50px;
    background-color: #409eff;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: 50px;
    text-align: center;
  }
  .menuBox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 70px 20px 20px;
    .boxList {
      display: flex;
      flex-direction: column;
      width: 48%;
      height: 160px;
      border-radius: 6px;
      text-align: center;
      margin-bottom: 20px;
      position: relative;
      img {
        margin: 20px auto 10px;
        height: 90px;
      }
      p {
        display: block;
        color: #F3F8F3;
        padding: 0;
        margin: 0 0 15px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
      }
    }
    .box00 {
      background-color: #BC8F8F;
    }
    .box01 {
      background-color: #36AB60;
    }
    .box02 {
      background-color: #E98F36;
    }
    .box03 {
      background-color: #D81E06;
    }
    .box04 {
      background-color: #A4579D;
    }
    .box05 {
      background-color: #1195DB;
    }
    .box06 {
      background-color: #145fe1;
    }
    .box07 {
      background-color: #171291;
    }
    .box08 {
      background-color: rgba(0, 0, 0, 0.9);
    }
    .box09 {
      background-color: #A4579D;
    }
    .box10 {
      background-color: #1195DB;
    }
  }
}
.no-order {
  padding-top: 3rem;
  text-align: center;
  span {
    font-size: 1.8rem;
  }
}

.bottomBeian {
  position: fixed;
  bottom: 0;
  font-size: 12px;
  padding: 8px 0;
  text-align: center;
  color: #000;
  z-index: 9;
  display: block;
  width: 100%;
  left: 0;
}
</style>
